import { render, staticRenderFns } from "./CDropdownItem.vue?vue&type=template&id=24065085&scoped=true&"
import script from "./CDropdownItem.vue?vue&type=script&lang=js&"
export * from "./CDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./CDropdownItem.vue?vue&type=style&index=0&id=24065085&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24065085",
  null
  
)

export default component.exports